import { MirageTheme } from "@mirage/theme/MuiMirage.module";
import { createTheme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";
import type {} from "@mirage/MuiThemeDeclaration";
import type {} from "@mui/x-data-grid/themeAugmentation";
import type {} from "@mui/x-date-pickers/themeAugmentation";

const PublicPortalColors = {
    publicPortalPrimary: "#0357a6",
    publicPortalPrimaryHover: alpha("#0357a6", 0.8),
    publicPortalSmallHover: alpha("#04569f", 0.8),
    publicPortalSecondaryFocus: alpha("#0357a6", 0.4),
    publicPortalCard: "#f7f7f7",
    publicPortalGrey: "#636363",
    publicPortalSuccess: "#146A6A",
    publicPortalError: "#E74C3C",
    publicPortalErrorLight: "#f44336",
};

const PublicPortalTheme = createTheme(MirageTheme, {
    palette: {
        primary: {
            main: PublicPortalColors.publicPortalPrimary,
        },
        secondary: {
            main: "#000",
        },
        success: {
            main: PublicPortalColors.publicPortalSuccess,
        },
        error: {
            main: PublicPortalColors.publicPortalError,
            light: PublicPortalColors.publicPortalErrorLight,
        },
        grey: {
            "50": "#fafafa",
            "100": "#f5f5f5f5",
            "200": "#eeeeee",
            "300": "#e0e0e0",
            "400": "#bdbdbd",
            "500": "#9e9e9e",
            "600": "#757575",
            "700": "#616161",
            "800": "#424242",
            "900": "#212121",
            A100: "#f5f5f5",
            A200: "#eeeeee",
            A400: "#bdbdbd",
            A700: "#616161",
        },
    },
    typography: {
        cardContent: {
            fontSize: "0.8rem",
            lineHeight: "1.2rem",
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 1000,
                },
            },
        },
        MuiContainer: {
            styleOverrides: {
                maxWidthXl: {
                    maxWidth: "90% !important",
                },
            },
        },
        MuiTypography: {
            defaultProps: {
                variantMapping: {
                    cardContent: "p",
                },
            },
            styleOverrides: {
                button: {
                    color: PublicPortalColors.publicPortalPrimary,
                    textTransform: "none",
                    ":hover": {
                        color: PublicPortalColors.publicPortalPrimaryHover,
                        textDecoration: "underline",
                        cursor: "pointer",
                    },
                },
            },
        },
        MuiCardHeader: {
            styleOverrides: {
                title: {
                    fontSize: "1rem",
                },
                subheader: {
                    fontSize: "0.8rem",
                    lineHeight: "1rem",
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    "&.Mui-selected": {
                        color: PublicPortalColors.publicPortalPrimary,
                    },
                    textTransform: "none",
                    color: PublicPortalColors.publicPortalGrey,
                    fontSize: "1.5rem",
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                flexContainer: {
                    justifyContent: "space-evenly",
                },
            },
        },
        MuiDataGrid: {
            styleOverrides: {
                cellContent: {
                    display: "-webkit-box",
                    "-webkit-line-clamp": "3",
                    "-webkit-box-orient": "vertical",
                },
            },
        },
    },
    icons: {
        sizeS: { width: "16px", height: "16px" },
        sizeM: { width: "24px", height: "24px" },
        sizeL: { width: "42px", height: "42px" },
    },
    entityTable: {
        publicOnly: true,
    },
});

export { PublicPortalTheme };
